import { Layout } from "antd";
import { useLocation } from "react-router-dom";
import Comment from "src/components/Comment";
import { blacklistViewComment } from "src/entity/comment/comment.entity";

const { Footer } = Layout;

const Footers = () => {
  const location = useLocation();
  const { pathname } = location;

  return <Footer className="p-2">{!blacklistViewComment.includes(pathname) && <Comment path={pathname} />}</Footer>;
};

export default Footers;
